exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".obj-dialog[data-v-d7cec3aa]{background-image:var(--dialogBgImg);padding:20px}.obj-dialog[data-v-d7cec3aa],.obj-dialog .header[data-v-d7cec3aa]{background-repeat:no-repeat;background-size:100% 100%}.obj-dialog .header[data-v-d7cec3aa]{background-image:var(--diyCardTitleBg);height:36px;line-height:40px}", ""]);

// exports
